import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import FilterByType from './FilterByType';
import Icon from '../Icon/index';
import styles from './Facets.module.less';

const Facets = ({
  allFacets,
  open,
  onClick,
  closeFilterWrap,
  clearFilters,
}) => {
  const facets = allFacets.map(facet => (
    <FilterByType
      key={facet.internalName}
      facetObject={facet}
      onClick={onClick}
    />
  ));

  const rootRef = useRef();

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleClickOutside = e => {
    //close filter wrap if user clicks outside of it
    return rootRef.current.contains(e.target) ? null : closeFilterWrap();
  };

  const handleClearFilters = e => {
    e.preventDefault();
    clearFilters();
  };

  return (
    <div
      className={clsx(styles.searchFilter, open && styles.open)}
      ref={rootRef}
      role="navigation"
    >
      <ul>
        <li className={styles.closeFilterWrap} onClick={closeFilterWrap}>
          <Icon name="cancel-light" className={styles.removeIcon} />
        </li>
        <li className={styles.filterResultsTitle}>
          <h4>Filter Results</h4>
        </li>
        <li className={styles.clearLink}>
          <a href="/resources/" onClick={handleClearFilters}>
            clear all filters
          </a>
        </li>
        {facets}
      </ul>
    </div>
  );
};

export default Facets;

Facets.propTypes = {
  allFacets: PropTypes.array,
  open: PropTypes.bool,
  onClick: PropTypes.func,
  closeFilterWrap: PropTypes.func,
  clearFilters: PropTypes.func,
};
